<div class="vehicle-features__list clearfix">
  <ul>
    <li *ngIf="options?.numberSeats" class="vehicle-features__list--people">
      x{{options?.numberSeats | range:'-'}}
    </li>
    <li *ngIf="options?.numberLargeBags" class="vehicle-features__list--storage">
      x{{options?.numberLargeBags| range:'-'}}
    </li>
    <li *ngIf="options?.numberDoors" class="vehicle-features__list--doors">
      x{{options?.numberDoors| range:'/'}}
    </li>
    <li *ngIf="options?.isAirConditioning" class="vehicle-features__list--ac">A/C</li>
  </ul>
</div>
